// Vendors
import React from 'react';
import { Typography } from '@mui/material';

// Components
import ReusablePopup from '@/components/organism/PopUp/ReusablePopup/ReusablePopup';

// Models
import { POPUP_TYPES } from '@/utils/constants';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  deficiencyList: string[] | []; // Passed from Redux or parent component
}

const DeficiencyPopup: React.FC<Props> = ({ isOpen, onClose, deficiencyList }) => {
  return (
    <ReusablePopup
      isOpen={isOpen}
      onClose={onClose}
      typeClassName="contract-details-popup"
      header="Deficiency Codes"
      type={POPUP_TYPES.DEFICIENCY_DETAILS}
    >
      {deficiencyList.map((code, index) => (
        <Typography key={index} className="popup-content">
          {code}
        </Typography>
      ))}
    </ReusablePopup>
  );
};

export default DeficiencyPopup;
